import { Component, Input, OnInit } from '@angular/core';
import { AtividadeAditamentoService } from 'src/app/core/services/atividade-aditamento.service';


@Component({
  selector: 'sgc-atividade-aditamento-list',
  templateUrl: './atividade-aditamento-list.component.html',
  styleUrls: ['./atividade-aditamento-list.component.scss']
})
export class AtividadeAditamentoListComponent implements OnInit {
  @Input() idAtividade!: number;
  aditamentos: any[] = [];

  constructor(private atividadeAditamentoService: AtividadeAditamentoService) {}

  ngOnInit(): void {
    if (this.idAtividade) {
      this.atividadeAditamentoService.listarAditamentos(this.idAtividade).subscribe({
        next: (res) => this.aditamentos = res,
        error: (err) => console.error('Erro ao buscar aditamentos:', err)
      });
    }
  }
}
